var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "10px" } },
    [
      _c(
        "el-table",
        {
          attrs: {
            border: "",
            data: _vm.tableList,
            "header-cell-style": _vm.headerCellStyle,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              prop: "date",
              type: "index",
              label: "序号",
              align: "center",
              width: "60px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.currentPage - 1) * _vm.pageSize +
                            scope.$index +
                            1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              prop: "handleFileNumber",
              align: "center",
              label: "处理文件文号",
              "show-overflow-tooltip": true,
              "min-width": "160px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "handleDepartment",
              align: "center",
              label: "实施/认定部门",
              "show-overflow-tooltip": true,
              "min-width": "160px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "date",
              label: "决定内容",
              "show-overflow-tooltip": true,
              align: "center",
              width: "200px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "punishDate",
              align: "center",
              label: "处罚时间",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          scope.row.punishDate
                            ? _vm.formatDate(scope.row.punishDate, "yyyy-MM-dd")
                            : "--"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "punishContent",
              label: "处罚事由(违法违规事项名称)",
              align: "center",
              "show-overflow-tooltip": true,
              width: "200px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "dataSource",
              align: "center",
              label: "数据来源",
              "show-overflow-tooltip": true,
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "登记时间",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          scope.row.createTime
                            ? _vm.formatDate(scope.row.createTime, "yyyy-MM-dd")
                            : "--"
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }